const currentTheme = localStorage.getItem('currentTheme');

const initialState = {
    currentTheme: currentTheme || 'Light'
};

export default function ThemeReducer(state = initialState, action) {
    switch (action.type) {
        case "TOGGLE_THEME": {
            return {
                ...state,
                currentTheme: action.currentTheme
            };
        }

        default: {
            return state;
        }
    }
}